/*
 *###############################################################################
 *Module Name                   : StockCountSheet.js                            #
 *Purpose of the Module         :                                               #
 *Description of the Module     :                                               #
 *Original Author               :  T A C Priyashad                              #
 *Date                          : Tuesday, March 24th 2022, 8:59:53 pm          #
 *Copyright (c) 2022 myPOS Software Solution (pvt Ltd.)                         #
 *###############################################################################
 */

import React from "react"
import { CardText, Col, Row, Alert, Button, Modal, Table, Label } from "reactstrap"
import DPTextBox from "framework/components/DPTextBox"
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"
import DPSwitch from "framework/components/DPSwitch"
import DPDropDown from "framework/components/DPDropDown"
import DBRadioButtonStockFreeze from "framework/components/DBRadioButtonStockFreeze"

const StockCountSheet = ({
  Gen_strBatch,
  Gen_Batch_OnChange,
  Gen_blBatchEnable,
  Gen_Batch_Blur,
  Gen_strLocation,
  Gen_Location_OnChange,
  Gen_blLocationEnable,
  Gen_LocationBlur,
  BatchSelect,
  LocationSelect,
  tog_xlargeB,
  tog_xlargeL,
  modal_xlargeB,
  modal_xlargeL,
  menuCode,
  handlePrintSV,
  handlePrintSVH,
  viewRpt,
  setViewRpt,
  addZero,
  setAddZero,
  setAlertConfirmOption,
  setAlertDescription,
  setsweetAlertShow,
  allLocations,
  txnType,
  setTxnTypeOnChange,
  txnTypes
}) => {



  const radio = [{ label: "Stock Count Sheet", value: "1" }, { label: "Stock Variance ", value: "2" }, { label: "Post Stock Adjustment", value: "4" }]
  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ]


  return (
    <React.Fragment>
      <div>
        <Row>
          <Col sm="12">
            <DBRadioButtonStockFreeze
              rowClass="mb-12-sm"
              labelText=""
              types={radio}
              value={viewRpt}
              OnChange={setViewRpt}
              Disabled={false}
              labelShow={false}

            />
          </Col>
        </Row>
        <Col sm="12">
          {viewRpt == "1" ? (<div>
            <h5>Stock Count Sheet</h5>
            <CardText className="mb-0">
              <Row>
                <Col sm={12} md={10} className="mb-4-sm">
                  <Row>
                    <Col sm={12} md={6} className="mb-4-sm">
  
                      <DPDropDown
                        labelText={"Location"}
                        optionGroup={allLocations}
                        selectedGroup={Gen_strLocation}
                        onChange={Gen_Location_OnChange}
                        disabled={Gen_blLocationEnable}
                      />
                      <DPDropDown
                        rowClass="mb-4-sm"
                        labelText={"TXN Type"}
                        selectedGroup={txnType}
                        onChange={setTxnTypeOnChange}
                        disabled={Gen_strLocation == "" ? true : false}
                        optionGroup={txnTypes}
                      />
                    </Col>

                  </Row>
                  <Row>
                    <Col sm={12} md={6} className="mb-4-sm">
                      <DPTextBox
                        rowClass="mb-4-sm"
                        labelText="Batch"
                        textType="text"
                        maxLength="25"
                        LableClass="col-md-4 col-form-label-sm"
                        TextBoxClass="col-md-8"
                        value={Gen_strBatch}
                        onChange={Gen_Batch_OnChange}
                        disabled={true}
                        onBlur={Gen_Batch_Blur}
                      />
                    </Col>
                    <Col sm={12} md={1} className="mb-4-sm">
                      <Button
                        color="success"
                        className="btn-sm"
                        disabled={txnType == "" ? true : false}
                        onClick={tog_xlargeB}
                        style={{ height: "26px" }}
                      >
                        <i
                          className="mdi mdi-search-web"
                          style={{ fontSize: "12px" }}
                        ></i>
                      </Button>
                    </Col>
                  </Row>

                  <DPSearchBoxDynamic
                    searchData={[]}
                    columns={[]}
                    defaultSorted={defaultSorted}
                    mainTitle={"Batch Search"}
                    SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                    isOpen={modal_xlargeB}
                    toggle={tog_xlargeB}
                    getSelect={BatchSelect}
                    APIURL={window.Links.ApiURL}
                    URLPath={"BATCH"}
                    MenuCode={menuCode}
                    KeyVal={txnType}
                    searchBy={"HED_RUNNO"}
                    FilterStr={`AND HED_LOCFROM ='${Gen_strLocation}'`}
                  />
                  <DPSearchBoxDynamic
                    searchData={[]}
                    columns={[]}
                    defaultSorted={defaultSorted}
                    mainTitle={"Location Search"}
                    SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                    isOpen={modal_xlargeL}
                    toggle={tog_xlargeL}
                    getSelect={LocationSelect}
                    APIURL={window.Links.ApiURL}
                    URLPath={"LOCATIONFRZ"}
                    MenuCode={menuCode}
                    KeyVal={txnType}
                    searchBy={"LOC_CODE"}
                    FilterStr={"a"}
                  />
                </Col>
              </Row>
            </CardText>
          </div>) : null}
          {viewRpt == "2" ? (<div>
            <h5>Stock Variance</h5>
            <CardText className="mb-0">
              <Row>
                <Col sm={12} md={10} className="mb-4-sm">
                  <Row>
                    <Col sm={12} md={6} className="mb-4-sm">
                      <DPDropDown
                        labelText={"Location"}
                        optionGroup={allLocations}
                        selectedGroup={Gen_strLocation}
                        onChange={Gen_Location_OnChange}
                        disabled={Gen_blLocationEnable}
                      />
                      <DPDropDown
                        rowClass="mb-4-sm"
                        labelText={"TXN Type"}
                        selectedGroup={txnType}
                        onChange={setTxnTypeOnChange}
                        disabled={Gen_strLocation == "" ? true : false}
                        optionGroup={txnTypes}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={12} md={6} className="mb-4-sm">
                      <DPTextBox
                        rowClass="mb-4-sm"
                        labelText="Batch"
                        textType="text"
                        maxLength="25"
                        LableClass="col-md-4 col-form-label-sm"
                        TextBoxClass="col-md-8"
                        value={Gen_strBatch}
                        onChange={Gen_Batch_OnChange}
                        disabled={true}
                        onBlur={Gen_Batch_Blur}
                      />
                    </Col>
                    <Col sm={12} md={1} className="mb-4-sm">
                      <Button
                        color="success"
                        className="btn-sm"
                        disabled={txnType == "" ? true : false}
                        onClick={tog_xlargeB}
                        style={{ height: "26px" }}
                      >
                        <i
                          className="mdi mdi-search-web"
                          style={{ fontSize: "12px" }}
                        ></i>
                      </Button>
                    </Col>
                    {/* <Col sm={12} md={1} className="mb-4-sm">
                      <Button
                        color="success"
                        className="btn-sm"
                        disabled={Gen_blBatchEnable}
                        onClick={() => {
                          handlePrintSV("PDF")
                        }}
                        style={{ height: "26px" }}
                      >
                        <i
                          className="mdi mdi-printer"
                          style={{ fontSize: "12px" }}
                        ></i>
                      </Button>
                    </Col> */}
                  </Row>

                  <DPSearchBoxDynamic
                    searchData={[]}
                    columns={[]}
                    defaultSorted={defaultSorted}
                    mainTitle={"Batch Search"}
                    SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                    isOpen={modal_xlargeB}
                    toggle={tog_xlargeB}
                    getSelect={BatchSelect}
                    APIURL={window.Links.ApiURL}
                    URLPath={"BATCH"}
                    MenuCode={menuCode}
                    KeyVal={txnType}
                    searchBy={"HED_RUNNO"}
                    FilterStr={`AND HED_LOCFROM ='${Gen_strLocation}'`}
                  />
                  <DPSearchBoxDynamic
                    searchData={[]}
                    columns={[]}
                    defaultSorted={defaultSorted}
                    mainTitle={"Location Search"}
                    SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                    isOpen={modal_xlargeL}
                    toggle={tog_xlargeL}
                    getSelect={LocationSelect}
                    APIURL={window.Links.ApiURL}
                    URLPath={"LOCATIONFRZ"}
                    MenuCode={menuCode}
                    KeyVal={"TXN"}
                    searchBy={"LOC_CODE"}
                    FilterStr={"a"}
                  />
                </Col>
              </Row>
            </CardText>
          </div>) : null}
          {viewRpt == "3" ? (<div>
            <h5>Stock Variance History</h5>
            <CardText className="mb-0">
              <Row>
                <Col sm={12} md={10} className="mb-4-sm">
                  <Row>
                    <Col sm={12} md={6} className="mb-4-sm">

                      <DPDropDown
                        labelText={"Location"}
                        optionGroup={allLocations}
                        selectedGroup={Gen_strLocation}
                        onChange={Gen_Location_OnChange}
                        disabled={Gen_blLocationEnable}
                      />
                      <DPDropDown
                        rowClass="mb-4-sm"
                        labelText={"TXN Type"}
                        selectedGroup={txnType}
                        onChange={setTxnTypeOnChange}
                        disabled={Gen_strLocation == "" ? true : false}
                        optionGroup={txnTypes}
                      />
                    </Col>

                  </Row>
                  <Row>
                    <Col sm={12} md={6} className="mb-4-sm">
                      <DPTextBox
                        rowClass="mb-4-sm"
                        labelText="Batch"
                        textType="text"
                        maxLength="25"
                        LableClass="col-md-4 col-form-label-sm"
                        TextBoxClass="col-md-8"
                        value={Gen_strBatch}
                        onChange={Gen_Batch_OnChange}
                        disabled={true}
                        onBlur={Gen_Batch_Blur}
                      />
                    </Col>
                    <Col sm={12} md={1} className="mb-4-sm">
                      <Button
                        color="success"
                        className="btn-sm"
                        disabled={txnType == "" ? true : false}
                        onClick={tog_xlargeB}
                        style={{ height: "26px" }}
                      >
                        <i
                          className="mdi mdi-search-web"
                          style={{ fontSize: "12px" }}
                        ></i>
                      </Button>
                    </Col>
                    <Col sm={12} md={1} className="mb-4-sm">
                      <Button
                        color="success"
                        className="btn-sm"
                        disabled={Gen_blBatchEnable}
                        onClick={() => {
                          handlePrintSVH("PDF")
                        }}
                        style={{ height: "26px" }}
                      >
                        <i
                          className="mdi mdi-printer"
                          style={{ fontSize: "12px" }}
                        ></i>
                      </Button>
                    </Col>
                  </Row>

                  <DPSearchBoxDynamic
                    searchData={[]}
                    columns={[]}
                    defaultSorted={defaultSorted}
                    mainTitle={"Batch Search"}
                    SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                    isOpen={modal_xlargeB}
                    toggle={tog_xlargeB}
                    getSelect={BatchSelect}
                    APIURL={window.Links.ApiURL}
                    URLPath={"BATCH"}
                    MenuCode={menuCode}
                    KeyVal={txnType}
                    searchBy={"HED_RUNNO"}
                    FilterStr={`AND HED_LOCFROM ='${Gen_strLocation}'`}
                  />
                  <DPSearchBoxDynamic
                    searchData={[]}
                    columns={[]}
                    defaultSorted={defaultSorted}
                    mainTitle={"Location Search"}
                    SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                    isOpen={modal_xlargeL}
                    toggle={tog_xlargeL}
                    getSelect={LocationSelect}
                    APIURL={window.Links.ApiURL}
                    URLPath={"LOCATIONFRZ"}
                    MenuCode={menuCode}
                    KeyVal={"TXN"}
                    searchBy={"LOC_CODE"}
                    FilterStr={"a"}
                  />
                </Col>
              </Row>
            </CardText>
          </div>) : null}
          {viewRpt == "4" ? (<div>
            <h5>Post Stock Adjustment</h5>
            <CardText className="mb-0">
              <Row>
                <Col sm={12} md={6} className="mb-4-sm">
                  <Row>
                    <Col sm={12} md={10} className="mb-4-sm">

                      <DPDropDown
                        labelText={"Location"}
                        optionGroup={allLocations}
                        selectedGroup={Gen_strLocation}
                        onChange={Gen_Location_OnChange}

                        disabled={Gen_blLocationEnable}
                      />
                      <DPDropDown
                        rowClass="mb-4-sm"
                        labelText={"TXN Type"}
                        selectedGroup={txnType}
                        onChange={setTxnTypeOnChange}
                        disabled={Gen_strLocation == "" ? true : false}
                        optionGroup={txnTypes}
                      />
                    </Col>

                  </Row>
                  <Row>
                    <Col sm={12} md={10} className="mb-4-sm">
                      <DPTextBox
                        rowClass="mb-4-sm"
                        labelText="Batch"
                        textType="text"
                        maxLength="25"
                        LableClass="col-md-4 col-form-label-sm"
                        TextBoxClass="col-md-8"
                        value={Gen_strBatch}
                        onChange={Gen_Batch_OnChange}
                        disabled={true}
                        onBlur={Gen_Batch_Blur}
                      />
                    </Col>
                    <Col sm={12} md={1} className="mb-4-sm">
                      <Button
                        color="success"
                        className="btn-sm"
                        disabled={txnType == "" ? true : false}
                        onClick={tog_xlargeB}
                        style={{ height: "26px" }}
                      >
                        <i
                          className="mdi mdi-search-web"
                          style={{ fontSize: "12px" }}
                        ></i>
                      </Button>
                    </Col>
                  </Row>

                  <DPSearchBoxDynamic
                    searchData={[]}
                    columns={[]}
                    defaultSorted={defaultSorted}
                    mainTitle={"Batch Search"}
                    SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                    isOpen={modal_xlargeB}
                    toggle={tog_xlargeB}
                    getSelect={BatchSelect}
                    APIURL={window.Links.ApiURL}
                    URLPath={"BATCH"}
                    MenuCode={menuCode}
                    KeyVal={txnType}
                    searchBy={"HED_RUNNO"}
                    FilterStr={`AND HED_LOCFROM ='${Gen_strLocation}'`}
                  />
                  <DPSearchBoxDynamic
                    searchData={[]}
                    columns={[]}
                    defaultSorted={defaultSorted}
                    mainTitle={"Location Search"}
                    SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                    isOpen={modal_xlargeL}
                    toggle={tog_xlargeL}
                    getSelect={LocationSelect}
                    APIURL={window.Links.ApiURL}
                    URLPath={"LOCATIONFRZ"}
                    MenuCode={menuCode}
                    KeyVal={"TXN"}
                    searchBy={"LOC_CODE"}
                    FilterStr={"a"}
                  />
                </Col>
                <Col sm={12} md={6} className="mb-4-sm">
                  <Row>
                    <Col sm={12} md={2} className="mb-4-sm">
                      <DPSwitch
                        checked={addZero}
                        disabled={false}
                        onChange={() => {
                          //setAddZero(prev => !prev)
                          if (addZero == false) {
                            setAlertDescription("Are you sure you want to update the uncounted stock as zero?")
                            setAlertConfirmOption(7)
                            setsweetAlertShow(true)
                          } else {
                            setAddZero(false)
                          }
                        }}
                      />
                    </Col>
                    <Col sm={12} md={10} className="mb-4-sm">
                      <Label
                        htmlFor="example-text-input"
                        className="col-md-12 col-form-label-sm">Update uncounted stock as zero</Label>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={12} md={2} className="mb-4-sm"></Col>
                    <Col sm={12} md={10} className="mb-4-sm">
                      <Label
                        htmlFor="example-text-input"
                        className="col-md-12 col-form-label-sm">Check above to make all the uncounted stocks to zero. System will post an entry to update the
                        uncounted items and adjust the values to zero. Please use this option only if you are fully aware of the action or otherwise ask your system administrator.
                      </Label>
                    </Col>

                  </Row>

                </Col>
              </Row>
            </CardText>
          </div>) : null}
        </Col>
      </div>
    </React.Fragment>
  )
}

export default StockCountSheet
